export default {
    concept: {},
    categoryItems: {},
    inactiveCategories: [],
};
